import { useState } from "react";
import { faqs } from "@/mocks/anime";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            你可能想问的
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm md:text-base text-foreground-600">
            关于小狗看番的收录规则、评分来源与使用方式，常见疑问一次说清。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl bg-background-50 border border-background-200/70"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 md:px-6 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-950">
                    {f.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${
                      open ? "rotate-180 bg-primary-500 text-background-50" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}